import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChat = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	strokeWidth: 2,
	stroke: "currentColor",
	strokeMiterlimit: 10,
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 9C13.928 9 9 13.62 9 19.3125C9 22.6538 9.6875 24.8125 12.4375 27.5625L20 33.75V29.625C26.072 29.625 31 25.005 31 19.3125C31 13.62 26.072 9 20 9Z" })
});
const ForwardRef = forwardRef(SvgChat);
export default ForwardRef;
